import type { ReactElement } from 'react';

export default function SidebarCountBadge({ count }: { count: number | string }): ReactElement {
  return (
    <span className="vtwo:flex vtwo:h-[15px] vtwo:min-w-[15px] vtwo:shrink-0 vtwo:items-center vtwo:justify-center vtwo:rounded-full vtwo:bg-[#cb2e2e] vtwo:px-1 vtwo:text-[10px] vtwo:font-medium vtwo:leading-none vtwo:text-white">
      {count}
    </span>
  );
}
